import {View, Text,StyleSheet,Platform, Linking} from 'react-native';
import  {AntDesign}  from '@expo/vector-icons';




export default function Footer(){
  const URL = "https://google.com";

  return (
 <View style={styles.container}>
   <View style={styles.social}>
   <Text style={styles.textColor}>Follow me on:</Text>
   <View style={styles.github}>
       <AntDesign name="github" size={24} color="white" onPress={()=>Linking.openURL('https://github.com/eyobel7k')} />
   </View>
 <View style={styles.linkedIn}>
   <AntDesign name="linkedin-square" size={24} color="white"     onPress={() => Linking.openURL('https://www.linkedin.com/in/eyob7k/')}/>
   </View>
   <View style={styles.twitter}>

   </View>
  
   <AntDesign name="twitter" size={24} color="white" onPress={()=>Linking.openURL('https://twitter.com/7Limitless7')}/>
   </View>
   
   
                
   </View>


  )
}
const styles= StyleSheet.create({
  container:{
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    borderTopWidth: 3,
    padding: 5,
    // borderColor: "black",
    backgroundColor: "#000304",
    flexDirection: "row", 
  },
  textColor: {
    color: "#fff",
    fontSize: 13,
    textAlign: "center",
    marginRight:12,
    marginTop:Platform.OS==='web'?8:null,
  },
  social:{
    flexDirection:'row', 
    
  },
  linkedIn:{
    marginRight:8,
  },
  github:{
    marginRight:8,
  }
  
 
})